import { Injectable } from '@angular/core';
import { FormbirdInjectorService } from '../injector/formbird-injector.service';

declare const angular: any;

@Injectable({
  providedIn: 'root'
})
export class DocumentListService {
  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('DocumentListService');
  }

  setupDocumentListId() {
    return this.ajsService.setupDocumentListId();
  }

  save() {
    return this.ajsService.save();
  }

  clearDocuments(documentListId) {
    this.ajsService.clearDocuments(documentListId);
  }
}
